import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Image, ProgressBar } from '../AbstractElements';
import { dynamicImage } from '../Utils';
import { getData } from '../CommonElements/Functions/PostGetFun';
import { API } from '../api/API';
import {
    prepareDexieSchema,
    insertDataToDexie,
    ColumnDefinition,
} from '../db/DexieServises';
import { generateColumnsAndDataFromResponse } from '../db/AddGetData';
import Dexie from 'dexie';

const FirstLoader: React.FC = () => {
    const serverUrl = localStorage.getItem('serverUrl');
    const APP_TOKEN = localStorage.getItem('appToken');
    const navigate = useNavigate();

    const handleSubmitAPI = async () => {
        if (!serverUrl || !APP_TOKEN) {
            console.error('❌ Missing server URL or app token');
            return;
        }

        const url = `${serverUrl}${API.getMasters}`;
        const masterKeys = ['User','Employee', 'Position', 'OrgUnit', 'Branch', 'Grade', 'Designation', 'RolePerms', 'Classification'];
        const allSchemas: Record<string, ColumnDefinition[]> = {};
        const allRecords: Record<string, Record<string, any>[]> = {};

        // 🟢 Step 1: Fetch and prepare master data
        for (const key of masterKeys) {
            // Initialize with default schema to ensure essential fields are indexed
            allSchemas[key] = [
                { name: 'id', type: 'number', isPrimaryKey: true },
                { name: 'OrgUnitId', type: 'number' },
                { name: 'PositionId', type: 'number' }
            ];
            if (key === 'Position') {
                allSchemas[key].push(
                    { name: 'PositionName', type: 'string' },
                    { name: 'EmployeeName', type: 'string' },
                    { name: 'EmployeeCode', type: 'string' },
                    { name: 'employee_name', type: 'string' },
                    { name: 'employee_code', type: 'string' }
                );
            }
            allRecords[key] = [];

            try {
                const { status, data } = await getData(url, true, { key });

                console.log(`📡 API Response for ${key}:`, { status, dataLength: data?.data?.length });
                
                if (status === 200 && Array.isArray(data?.data) && data.data.length > 0) {
                    const allColumnsSet: Map<string, ColumnDefinition> = new Map();
                    
                    // 🛡️ Pre-populate with defaults to ensure these fields are ALWAYS indexed
                    allSchemas[key].forEach(col => allColumnsSet.set(col.name, col));

                    const recordsArray: Record<string, any>[] = [];
                    let idCounter = 1;

                    for (const item of data.data) {
                        const { columns, records } = generateColumnsAndDataFromResponse(item, idCounter);
                        idCounter += 1;

                        if (Array.isArray(columns)) {
                            for (const col of columns) {
                                allColumnsSet.set(col.name, col);
                            }
                        }

                        if (Array.isArray(records)) {
                            recordsArray.push(...records);
                        }
                    }

                    const finalColumns = Array.from(allColumnsSet.values());
                    allSchemas[key] = finalColumns;
                    allRecords[key] = recordsArray;

                    localStorage.setItem(`schema_${key}`, JSON.stringify(finalColumns));
                    console.log(`✅ Schema created for ${key}:`, finalColumns.length, 'columns,', recordsArray.length, 'records');
                } else {
                    console.warn(`⚠️ Failed to fetch or no data for ${key}, using default empty table`, { status, data });
                }
            } catch (error) {
                console.error(`❌ Exception while fetching ${key}:`, error);
            }
        }



        // 🟢 Step 3: Prepare Dexie schema and insert all data
        console.log('🧩 Final Schemas Before Dexie Init:', Object.keys(allSchemas));
        console.log('🧩 Columns for RolePerms:', allSchemas['RolePerms']);

        if (!allSchemas['Employee']) {
            console.error('❌ Employee schema is missing. Skipping Employee table creation.');
        } else {
            console.log('✅ Employee schema found:', allSchemas['Employee']);
        }

        await Dexie.delete('DynamicDB');
        localStorage.removeItem('dexie_dynamic_version');
        localStorage.removeItem('dexie_schema_hash');

        localStorage.setItem('dexie_all_schema', JSON.stringify(allSchemas));
        await prepareDexieSchema(allSchemas, true); // 💡 forceVersionUpdate=true

        for (const key of Object.keys(allSchemas)) {
            const columns = allSchemas[key];
            const records = allRecords[key];

            if (Array.isArray(columns) && columns.length > 0 && Array.isArray(records)) {
                console.log(`📥 Inserting into ${key}:`, { columns, count: records.length });
                await insertDataToDexie(key, records);
            } else {
                console.warn(`⚠️ Skipping ${key} due to missing columns or records.`);
            }
        }


        console.log('✅ All master and session data inserted');
        navigate('/me');
    };

    useEffect(() => {
        handleSubmitAPI();
        // console.log('loader compo trigger');

    }, []);

    return (
        <div className="page-body">
            <div className="default-dashboard">
                <div className="d-flex align-items-center justify-content-center profile-media">
                    <div>
                        <Image
                            className="b-r-10 img-80"
                            src={dynamicImage('dashboard/loader.gif')}
                            alt="Loading..."
                        />
                    </div>
                    <ProgressBar color="success" value={75} />
                </div>
            </div>
        </div>
    );
};

export default FirstLoader;
